module.exports = __webpack_public_path__ + "static/media/register-white.70310f5a.svg";